import MakeModelChatQuestionType from '@/enums/MakeModelChatQuestionType';
import ChatQuestion from '@/models/vehicle/makeModelBot/chatQuestion';
import EnvService from '@/services/EnvironmentService';

export class MakeModelBotService {
    private static serviceInstance: MakeModelBotService;

    public static get instance() {
        // eslint-disable-next-line no-return-assign
        return this.serviceInstance || (this.serviceInstance = new this());
    }

    public async buildChatQuestions(makeId: number, modelId: number): Promise<ChatQuestion[]> {
        const response = await fetch(this.questionUrl(makeId, modelId));
        const json = await response.json();
        const chatQuestions = this.createChatQuestions(json);
        return this.sortQuestions(chatQuestions);
    }

    // Helper method to create ChatQuestion objects from JSON data
    private createChatQuestions(json: any[]): ChatQuestion[] {
        return json.map((item) => {
            const answers = item.answerResponses.map((response: any) => [response.answerKey, response.response]);
            return new ChatQuestion(
                item.questionTypeId as MakeModelChatQuestionType,
                item.questionText,
                item.questionInsight,
                new Map(answers),
                item.helpMessage
            );
        });
    }

    private sortQuestions(questions: ChatQuestion[]): ChatQuestion[] {
        if (questions.length === 0) {
            return questions;
        }
    
        const questionTypes = [
            MakeModelChatQuestionType.BodyStyle,
            MakeModelChatQuestionType.PowerPreference,
            MakeModelChatQuestionType.FuelType,
            MakeModelChatQuestionType.Transmission,
            MakeModelChatQuestionType.Trim,
            MakeModelChatQuestionType.Colour
        ];
    
        // Create a map to store questions by their type
        const questionMap = new Map<MakeModelChatQuestionType, ChatQuestion>();
        questions.forEach((question) => {
            questionMap.set(question.makeModelChatQuestionType, question);
        });
    
        // Retrieve questions in the order of questionTypes
        return questionTypes
            .map((type) => questionMap.get(type))
            .filter((question): question is ChatQuestion => question !== undefined);
    }

    private questionUrl(
        makeId : number,
        modelId : number
    ): string {
        return `https://tla-func-questions-configuration-${EnvService.getEnv()}.azurewebsites.net/api/questions/${makeId}/${modelId}`;
    }
}

// export a singleton instance in the global namespace
// eslint-disable-next-line import/prefer-default-export
export const makeModelBotService = MakeModelBotService.instance;
